// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uOVpUbPh4ooRaDZOyVfC{flex-direction:column;gap:4px;display:flex}.YR3Uv9nbjZsEeCpNdQ2F{margin-top:8px;margin-bottom:8px}.WAeUAOYEnbuIito2HJ4P{flex-direction:column;gap:4px;display:flex}.dmdz61oIodQchZWDyY8s{grid-template-columns:130px auto;align-items:flex-start;display:grid}.dmdz61oIodQchZWDyY8s .PmIjuFB6oEByOc9UT7bA{align-items:center;min-height:32px;padding-left:12px;display:flex}.dmdz61oIodQchZWDyY8s .PmIjuFB6oEByOc9UT7bA .zwgqDMMrtPYHk4UiVYeP{gap:8px;display:flex}.Y24z4Qw4PtMwSQ4f6Z8b{min-height:32px;color:var(--content-primary-tertiary);align-items:center;display:flex}.N26y_odyGg4KUeI3GRGQ{padding-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `uOVpUbPh4ooRaDZOyVfC`,
	"title": `YR3Uv9nbjZsEeCpNdQ2F`,
	"sendParamsWrapper": `WAeUAOYEnbuIito2HJ4P`,
	"grid": `dmdz61oIodQchZWDyY8s`,
	"value": `PmIjuFB6oEByOc9UT7bA`,
	"row": `zwgqDMMrtPYHk4UiVYeP`,
	"label": `Y24z4Qw4PtMwSQ4f6Z8b`,
	"wrapPlaceholderClassName": `N26y_odyGg4KUeI3GRGQ`
};
export default ___CSS_LOADER_EXPORT___;
